export default __webpack_public_path__ + "static/young-toddler3-6b9053e747b43bb1a519d5b051917462.jpg";